import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=2f7afe04"
import script from "./ModalWrapper.vue?vue&type=script&lang=ts"
export * from "./ModalWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports